/**
 * **갬블링 상인 — 사냥 말고 새 부위를 얻는 유일한 길.**
 *
 * > 사용자: *"무조건 50만원인데 최고급 이하로 나오지만 다양한 부위를 얻을 수
 * > 있는 **사냥 이외의 유일한 경로**고 그 덕에 은화를 소진 시킬 수 있지."*
 *
 * ── 이 화면이 답할 것 ────────────────────────────────────────
 *
 * *얼마인가 · 몇 개 나오나 · **무엇이 나올 확률이 얼마인가.***
 * 셋째를 감추면 이 상인은 **손해라는 사실을 숨기는 장치**가 된다.
 * 여기는 은화를 태우는 자리이지 속이는 자리가 아니라서, 분포를 그대로 보여준다.
 *
 * ⛔ **값·개수를 문장에 안 적는다**(45 지시). `world/gamble.js` 에서 읽는다 —
 * 65 가 다시 재면 화면이 저절로 따라온다. 손으로 적으면 **화면만 옛 값을 말한다.**
 *
 * ⚠ **거절 문장을 여기서 다시 쓰지 않는다.** 은화 부족·무게 초과는 서버가 이미
 * 말한다(*"짐이 무거워 1개를 다 들 수 없다"*). 화면이 같은 말을 따로 들고 있으면
 * 한쪽이 낡고, **낡은 쪽이 규칙으로 읽힌다.** 미리 막는 것은 `buyBtn` 이 모든
 * 화면에서 똑같이 하는 은화 부족 표시까지다.
 *
 * ⚠ **보내는 것은 `{ t:'gamble' }` 하나다.** 등급도 부위도 개수도 안 보낸다 —
 * 클라가 뭘 뽑을지 말하게 하면 그건 뽑기가 아니다.
 */
import { GAMBLE_PRICE, GAMBLE_PICKS, GAMBLE_POOL, GAMBLE_DIST } from '../../world/gamble.js';
import { gradeCol } from '../../world/map.js';
import { buyBtn, chanceNotice, muted, num, sec, split, npcHead, purse, taxPct, withTax } from './common.js';

/**
 * 확률을 **막대로도 보여준다.** 숫자만 있으면 *"상급이 잘 나온다"* 가 눈에 안 든다.
 * ⚠ 길이는 **가장 큰 값 대비**로 낸다 — 100 을 기준으로 그리면 전부 짧아져서
 * 차이가 안 보인다(그림이 숫자를 배신하는 그 부류다).
 */
function distRows() {
  const max = Math.max(...GAMBLE_DIST);
  return GAMBLE_POOL.map((g, i) => {
    const p = GAMBLE_DIST[i];
    return '<div class="gmrow">'
      + `<span class="gmname" style="color:${gradeCol(g.id)}">${g.name}</span>`
      + `<span class="gmbar"><i style="width:${Math.round((p / max) * 100)}%;`
      + `background:${gradeCol(g.id)}"></i></span>`
      + `<span class="gmpct">${(p * 100).toFixed(1)}%</span>`
      + '</div>';
  }).join('');
}

export function render(ctx) {
  const { y, at } = ctx;

  const focus = npcHead() + chanceNotice() + sec('갬블링 상인',
    `<div class="ux-facts"><div class="ux-fact"><small>한 번 결제</small><b><span class="ux-number">${num(withTax(GAMBLE_PRICE, y))}</span><small>은화</small></b></div>`
    + `<div class="ux-fact"><small>받는 장비</small><b><span class="ux-number">${GAMBLE_PICKS}</span><small>개 · 무작위 부위</small></b></div></div>`
    + muted(`뽑기 ${num(GAMBLE_PRICE)} + 왕도 세금 ${taxPct(y)}% · 부위는 고를 수 없다.`));

  const list = sec('무엇이 나오나 · 등급 확률', distRows())
    + muted('같은 부위·등급 +10 두 개를 합치면 승급할 수 있다.');

  /**
   * ★ **낮은 등급이 버릴 물건이 아니라는 것을 여기서 말한다.**
   * 50만을 걸고 하급이 나왔을 때 *"그래서 뭘 하라고"* 가 되면 아무도 두 번 안 한다.
   * 합치기·승급이 그 답이고, 그 둘을 모르는 사람에게는 이 자리가 유일한 안내다.
   */
  const act = `<div class="kv"><span>가진 은화 · 가방 + 창고</span><b>${num(purse(y))}</b></div>`
    + '<div class="ux-actions">' + buyBtn(`${num(withTax(GAMBLE_PRICE, y))} 은화로 뽑는다`, 'act.gamble()', {
    // GX2: `need`는 가격이 아니라 서버 행위 이름이다. 숫자를 넣으면 마을 안에서도
    // 존재하지 않는 행위라 판정되어 구매 버튼이 영원히 비활성화된다.
    y, at, price: withTax(GAMBLE_PRICE, y), need: 'gamble',
  }) + '</div>';

  return split(focus, list, act);
}
